import styled, { keyframes } from 'styled-components';
import { border, layout, position } from 'styled-system';

const pulse = keyframes`
	0% {
		background-position: 0% 0%;
	}
	100% {
		background-position: -135% 0%;
	}
`;

const StyledSkeleton = styled.span`
	background-color: var(--skeleton-placeholder-bg, --base-10);
	background-image: var(--skeleton-placeholder-bg-gradient, --base-10);
	background-size: 400% 400%;
	display: flex;
	margin-bottom: 5px;
	line-height: 1;
	animation: ${pulse} 1.2s ease-in-out infinite;
	${border}
	${layout}
	${position}
`;

/**
 * SkeletonPlaceholder component for rendering a skeleton/loading placeholder.
 *
 * @param {Object} props - Component props.
 * @param {string} [props.className] - Additional class names for styling.
 * @param {number} [props.borderRadius=1] - Border radius for the skeleton element.
 * @param {string|number} [props.width='100%'] - Width of the skeleton. Can be a CSS string (e.g. '100%', '10rem') or a number (interpreted as pixels).
 * @param {string|number} [props.height='1em'] - Height of the skeleton. Can be a CSS string or a number (interpreted as pixels).
 * @param {React.CSSProperties} [props.style] - Extra inline styles for the skeleton.
 * @param {...Object} rest - Any additional props passed to the underlying StyledSkeleton.
 * @returns {JSX.Element} The rendered SkeletonPlaceholder component.
 */
const SkeletonPlaceholder = ({ className = '', borderRadius = 1, width = '100%', height = '1em', ...rest }) => (
	<StyledSkeleton
		className={`${className} skeleton-placeholder`}
		borderRadius={borderRadius}
		width={width}
		height={height}
		{...rest}
	/>
);

export default SkeletonPlaceholder;
